import React from 'react';
import { Route as RouteDefinition } from '../../../types/route';
import { ProfileOwnerGiveState } from '../../../types/profileOwner';
import SubNavBarDesktop from './Desktop';
import SubNavBarMobile from './Mobile';
import { PapiUser } from '@wix/da-types-papi';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import { RestrictLoggedOutPayload } from '@wix/da-shared-react/pkg/redux/loggedout/actionCreators';

export interface SubNavBarProps {
  routes: RouteDefinition[];
  profileOwnerUser: PapiUser;
  giveState?: ProfileOwnerGiveState;
  isWatchingProfileOwner: boolean;
  isOwner: boolean;
  isLoggedIn: boolean;
  isMobile: boolean;
  isViewingAsVisitor?: boolean;
  pushBadgeModal: (
    name: 'llama' | 'cake',
    userId: number,
    title: string,
    onBadgeSent: () => void
  ) => void;
  pushPointsModal: (username: string, title: string) => void;
  initGiveState: () => void;
  onLlamaBadgeSent: () => void;
  onCakeBadgeSent: () => void;
  onStartChat: (user: PapiUser) => void;
  restrictLoggedOut: (payload: RestrictLoggedOutPayload) => void;
  biClickProfileNavBar: (linkName: string) => void;
  children?: any;
}

class SubNavBar extends React.Component<SubNavBarProps> {
  render() {
    return this.props.isMobile ? (
      <SubNavBarMobile {...this.props} />
    ) : (
      <SubNavBarDesktop {...this.props} />
    );
  }
}

export default withMobileContext(SubNavBar);
